import { Provider } from 'react-redux'
import { compose, createStore, applyMiddleware } from 'redux'
import thunk from '../lib/redux-thunk.js'
import { persistStore, persistCombineReducers, autoRehydrate } from 'redux-persist'
import { PersistGate } from 'redux-persist/es/integration/react'
import storage from 'redux-persist/lib/storage'
import user from '../reducer/user'
import auth from '../reducer/auth'
import firebase from '../reducer/firebase'
import loading from '../reducer/loading'
import terms from '../reducer/terms'
import localForage from 'localforage'
import subscriptionPlans from '../reducer/subscription-plans'
import reporter from '../lib/redux-reporter.js'
import lines from '../reducer/lines'
import photos from '../reducer/photos'
import tracks from '../reducer/tracks'
import layers from '../reducer/layers'
import layersDictionary from '../reducer/layers-dictionary'
import species from '../reducer/species'
import circles from '../reducer/circles'
import markers from '../reducer/markers'
import polygons from '../reducer/polygons'
import huntTypes from '../reducer/hunt-types'
import residences from '../reducer/residence'
import locationMessage from '../reducer/location-message'
import markerTypes25 from '../reducer/marker-types-25'
import markerTypes35 from '../reducer/marker-types-35'
import markerTypes105 from '../reducer/marker-types-105'
import notifications from '../reducer/notifications'
import leftToolbarState from '../reducer/left-toolbar-state'
import rightToolbarState from '../reducer/right-toolbar-state'
import userSettings from '../reducer/user-settings'
import changesLastCalled from '../reducer/changes-last-called'
import mapReference from '../reducer/map-reference'
import friendList from '../reducer/friend-list'
import userPreferences from '../reducer/user-preferences'
import markerGroups from '../reducer/marker-groups'
import filters from '../reducer/filters'
import topOffset from '../reducer/top-offset'
import featureFields from '../reducer/feature-fields'
import positionedModal from '../reducer/positioned-modal'
import weaponTypes from '../reducer/weapon-types'
import followers from '../reducer/followers'
import featuresBlocked from '../reducer/features-blocked'
import boundaries from '../reducer/boundaries'
import vendors from '../reducer/vendors'
import activeVendors from '../reducer/activeVendors.js'
import states from '../reducer/states.js'
import disableMapObj from '../reducer/disable-map-obj-state.js'
import infoWindow from '../reducer/infowindow-reducer.js'
import markerCenter from '../reducer/center-marker-reducer.js'
import weatherValue from '../reducer/weather-reducer.js'
import ProductionLayers from '../reducer/production-reducer.js'
import zoomLevel from '../reducer/zoomLevelToggleReducer.js'
import mapCenter from '../reducer/map-center-reducer.js'
import selectedObjId from '../reducer/map-object-id-reducer.js'
import friendsLocation from '../reducer/friends-location.js'
import friendsLocationMapObj from '../reducer/friends-location-mapObj.js'
import locationTimeInterval from '../reducer/friends-api-time-interval.js'
import selectedTabReducer from '../reducer/selected-tab-reducer.js'
import huntplannerMapReference from '../reducer/huntplanner-map-reference.js'
import landTrustMapReference from '../reducer/map-reference-land-trust.js'
import huntplannerStatesData from '../reducer/huntplanner-state-Filter-reducer.js'
import huntPlannerSelectedOtions from '../reducer/huntplanner-selected-options-reducer.js'
import huntPlannerRightMenuBar from '../reducer/huntplanner-menu-bar-reducer'
import huntPlannerLoader from '../reducer/huntPlanner-load-spinner-reducer.js'
import currentSubscription from '../reducer/huntplanner-subscription-reducer'
import huntPlannerFilterOptions from '../reducer/huntplanner-filterOptions'
import huntplannerMorefilters from '../reducer/huntplanner-morefilters-reducer'
import huntplannerMorefiltersExpand from '../reducer/huntplanner-morefilters-menu.js'
import huntplannerRightToolbar from '../reducer/huntplanner-expandrightToolbar'
import huntplannerActiveLayersDetails from '../reducer/huntplanner-curentLayerdetails.js'
import huntplannerActiveLayerPayload from '../reducer/huntplanner-activeLayerPayload.js'
import huntMapLoader from '../reducer/huntplanner-map-loader'
import zoomEvent from '../reducer/huntplanner-zoomevent.js'
import isHuntPlannerDisable from '../reducer/isHuntPlannerDisable.js'
import lantTrustPrivateLandDetails from '../reducer/lantTrustPrivateLandDetails.js'
import landTrustRightMenuBarObj from '../reducer/landtrustMenuBarReducer.js'
import privateLandFilterValues from '../reducer/privateLands-reducer.js'
import privateLandItems from '../reducer/private-land-items.js'
import landTrustMenuBar from '../reducer/landTrustMenuBar.js'
import privateLandsMarkersMapObj from '../reducer/private-land-markers-reducer.js'
import selectedPrivateLandPayload from '../reducer/private-land-payload.js'
import mapReferenceThreed from '../reducer/map-reference-threed.js'
import is3dMapselected from '../reducer/selected-3dMap.js'
// import labels from '../reducer/labels'
// import limiter from '../reducer/limiter'
// import editItem from '../reducer/edit-item'
// import basicLogin from '../reducer/basic-login'
// import featureData from '../reducer/feature-data'
// import staticMaps from '../reducer/static-maps.js'
// import selectedData from '../reducer/selected-data'
// import placeholder from '../reducer/placeholder.js'
// import profilePhoto from '../reducer/profile-photo'
// import activeLayers from '../reducer/active-layers'
// import markerCluster from '../reducer/marker-cluster'
// import ruggedMapMode from '../reducer/rugged-map-mode'
// import redirectToApp from '../reducer/redirect-to-app'
// import activeMapView from '../reducer/active-map-view'
// import activeBoundary from '../reducer/active-boundary'
// import logoutFunction from '../reducer/logout-function'
// import locationSharing from '../reducer/location-sharing'
// import currentActivities from '../reducer/current-activity'
// import selectedHuntUnit from '../reducer/selected-hunt-unit'
// import paymentModalShow from '../reducer/show-payment-modal'
// import friendChangesLastCalled from '../reducer/friend-changes-last-called'
// import boundsBeforReload from '../reducer/bounds-before-reload'
// import lineEditVisibility from '../reducer/line-edit-visibility'
// import photoEditVisibility from '../reducer/photo-edit-visibility'
// import trackEditVisibility from '../reducer/track-edit-visibility'
// import upgradeFromMarketing from '../reducer/upgrade-from-marketing'
// import friendListVisibility from '../reducer/friend-list-visibility'
// import sharingManagementVisibility from '../reducer/sharing-management-visibility'
// import circleEditVisibility from '../reducer/circle-edit-visibility'
// import markerEditVisibility from '../reducer/marker-edit-visibility'
// import lineCreateVisibiltiy from '../reducer/line-create-visibility'
// import polygonEditVisibility from '../reducer/polygon-edit-visibility'
// import subscriptionModalShow from '../reducer/show-subscription-modal'
// import photoCreateVisibility from '../reducer/photo-create-visibility'
// import markerCreateVisibility from '../reducer/marker-create-visibility'
// import circleCreateVisibility from '../reducer/circle-create-visibility'
// import polygonCreateVisibility from '../reducer/polygon-create-visibility'
// import boundaryCreateVisibility from '../reducer/boundary-create-visibility'
// import subscriptionPlanFeatures from '../reducer/subscription-plan-features'
// import favoriteLocationEditVisibility from '../reducer/favorite-location-edit-visibility'
// import friendsTutorialVisibility from '../reducer/friend-list-tutorial-visibility'
// import shareLocationTutorialVisibility from '../reducer/location-sharing-tutorial-visibility'
// import sharingLocation from '../reducer/share-location'
// import currentLocation from '../reducer/current-location'
// import filterVisibility from '../reducer/filters-visibility'
// import showSearchMarkerLabel from '../reducer/search-map-visibility'
// import windowSize from '../reducer/window-size'
// import measureUnit from '../reducer/settings-units'
// import coordsFormat from '../reducer/settings-coords'
// import userSettingsLastCalled from '../reducer/user-settings-last-called'
// import toolbarSettings from '../reducer/toolbar-settings'
// import toolbarSettingVisibility from '../reducer/toolbar-settings-visibility'
// import rightToolbarVisibility from '../reducer/right-toolbar-visibility'
// import userContentHandleVisibility from '../reducer/user-content-handle-visibilityt'
// import userContentItemVisibility from '../reducer/user-content-item-visibility'
// import userSubscription from '../reducer/user-subscription'

// import {
//   generalTutorialVisibility,
//   moveMarkerTutorialVisibility,
//   moveObjectTutorialVisibility,
//   customToolbarTutorialVisibility,
//   huntFilterTutorialVisibility
// } from '../reducer/tutorial'

// import singleLayers from '../reducer/single-layers'

const config = {
  key: 'basemap',
  storage: localForage,
  blacklist: ['layers', 'filters', 'limiter', 'topOffset', 'mapReferenceThreed']
}

let reducer = persistCombineReducers(config, {
  auth: auth,
  disableMapObj: disableMapObj,
  user: user,
  terms: terms,
  firebase: firebase,
  subscriptionPlans: subscriptionPlans,
  loading: loading,
  layers: layers,
  lines: lines,
  layersDictionary: layersDictionary,
  tracks: tracks,
  infoWindow: infoWindow,
  photos: photos,
  circles: circles,
  markers: markers,
  species: species,
  polygons: polygons,
  huntTypes: huntTypes,
  residences: residences,
  markerTypes25: markerTypes25,
  markerCenter: markerCenter,
  markerTypes35: markerTypes35,
  markerTypes105: markerTypes105,
  locationMessage: locationMessage,
  notifications: notifications,
  leftToolbarState: leftToolbarState,
  rightToolbarState: rightToolbarState,
  userSettings: userSettings,
  changesLastCalled: changesLastCalled,
  mapReference: mapReference,
  friendList: friendList,
  userPreferences: userPreferences,
  markerGroups: markerGroups,
  filters: filters,
  topOffset: topOffset,
  featureFields: featureFields,
  positionedModal: positionedModal,
  weaponTypes: weaponTypes,
  followers: followers,
  featuresBlocked: featuresBlocked,
  boundaries: boundaries,
  vendors: vendors,
  activeVendors: activeVendors,
  states: states,
  weatherValue: weatherValue,
  productionLayers: ProductionLayers,
  zoomLevel: zoomLevel,
  mapCenter: mapCenter,
  selectedObjId: selectedObjId,
  friendsLocation: friendsLocation,
  friendsLocationMapObj: friendsLocationMapObj,
  locationTimeInterval: locationTimeInterval,
  selectedTab: selectedTabReducer,
  huntplannerMapReference: huntplannerMapReference,
  huntplannerStatesData: huntplannerStatesData,
  huntPlannerSelectedOtions: huntPlannerSelectedOtions,
  huntPlannerLoader: huntPlannerLoader,
  currentSubscription: currentSubscription,
  huntPlannerFilterOptions: huntPlannerFilterOptions,
  huntplannerMorefilters: huntplannerMorefilters,
  huntplannerMorefiltersExpand: huntplannerMorefiltersExpand,
  huntplannerRightToolbar: huntplannerRightToolbar,
  huntPlannerUnitRightMenuBar: huntPlannerRightMenuBar,
  huntplannerActiveLayersDetails: huntplannerActiveLayersDetails,
  huntplannerActiveLayerPayload: huntplannerActiveLayerPayload,
  huntMapLoader: huntMapLoader,
  zoomEvent: zoomEvent,
  isHuntPlannerDisable: isHuntPlannerDisable,
  landTrustMapReference: landTrustMapReference,
  landTrustRightMenuBarObj: landTrustRightMenuBarObj,
  lantTrustPrivateLandDetails: lantTrustPrivateLandDetails,
  privateLandFilterValues: privateLandFilterValues,
  privateLandItems: privateLandItems,
  landTrustMenuBar: landTrustMenuBar,
  privateLandsMarkersMapObj: privateLandsMarkersMapObj,
  selectedPrivateLandPayload: selectedPrivateLandPayload,
  mapReferenceThreed: mapReferenceThreed,
  is3dMapselected: is3dMapselected


  // labels: labels,
  // limiter: limiter,
  // windowSize: windowSize,
  // editItem: editItem,
  // basicLogin: basicLogin,
  // staticMaps: staticMaps,
  // filterVisibility: filterVisibility,
  // featureData: featureData,
  // placeholder: placeholder,
  // activeLayers: activeLayers,
  // selectedData: selectedData,
  // profilePhoto: profilePhoto,
  // markerCluster: markerCluster,
  // notifications: notifications,
  // redirectToApp: redirectToApp,
  // ruggedMapMode: ruggedMapMode,
  // activeMapView: activeMapView,
  // activeBoundary: activeBoundary,
  // currentLocation: currentLocation,
  // sharingLocation: sharingLocation,
  // logoutFunction: logoutFunction,
  // locationSharing: locationSharing,
  // locationMessage: locationMessage,
  // selectedHuntUnit: selectedHuntUnit,
  // paymentModalShow: paymentModalShow,
  // boundsBeforReload: boundsBeforReload,
  // friendChangesLastCalled: friendChangesLastCalled,
  // currentActivities: currentActivities,
  // lineEditVisibility: lineEditVisibility,
  // photoEditVisibility: photoEditVisibility,
  // trackEditVisibility: trackEditVisibility,
  // circleEditVisibility: circleEditVisibility,
  // markerEditVisibility: markerEditVisibility,
  // lineCreateVisibiltiy: lineCreateVisibiltiy,
  // upgradeFromMarketing: upgradeFromMarketing,
  // friendListVisibility: friendListVisibility,
  // sharingManagementVisibility: sharingManagementVisibility,
  // photoCreateVisibility: photoCreateVisibility,
  // polygonEditVisibility: polygonEditVisibility,
  // markerCreateVisibility: markerCreateVisibility,
  // friendsTutorialVisibility: friendsTutorialVisibility,
  // shareLocationTutorialVisibility: shareLocationTutorialVisibility,
  // circleCreateVisibility: circleCreateVisibility,
  // polygonCreateVisibility: polygonCreateVisibility,
  // subscriptionPlanFeatures: subscriptionPlanFeatures,
  // favoriteLocationEditVisibility: favoriteLocationEditVisibility,
  // showSearchMarkerLabel: showSearchMarkerLabel,
  // measureUnit: measureUnit,
  // coordsFormat: coordsFormat,
  // userSettingsLastCalled: userSettingsLastCalled,
  // toolbarSettings: toolbarSettings,
  // toolbarSettingVisibility: toolbarSettingVisibility,
  // rightToolbarVisibility: rightToolbarVisibility,
  // userContentHandleVisibility: userContentHandleVisibility,
  // userContentItemVisibility: userContentItemVisibility,
  // generalTutorialVisibility: generalTutorialVisibility,
  // moveMarkerTutorialVisibility: moveMarkerTutorialVisibility,
  // moveObjectTutorialVisibility: moveObjectTutorialVisibility,
  // customToolbarTutorialVisibility: customToolbarTutorialVisibility,
  // huntFilterTutorialVisibility: huntFilterTutorialVisibility,
  // boundaryCreateVisibility: boundaryCreateVisibility,
  // userSubscription: userSubscription,
  // singleLayers: singleLayers,
})

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
/* eslint-disable no-underscore-dangle */
export const store = createStore(
  reducer,
  composeEnhancer(applyMiddleware(thunk, reporter))
)
/* eslint-enable */


//refresh before reload
import { layersSet } from '../action/layer-actions'
import { filterClear } from '../action/filters-actions'
import { huntTypesSet } from '../action/hunt-types-actions'
import { speciesSet } from '../action/species-actions'
import { weaponTypesSet } from '../action/weapon-types-actions'
import { clearTopOffset } from '../action/top-offset'
import { closeModal } from '../action/positioned-modal-state'
import { unBlockFeatures } from '../action/features-blocked-actions.js'

window.addEventListener('beforeunload', () => {
  store.dispatch(layersSet({}))
  store.dispatch(huntTypesSet([]))
  store.dispatch(closeModal())
  store.dispatch(speciesSet([]))
  store.dispatch(weaponTypesSet([]))
  store.dispatch(filterClear())
  store.dispatch(clearTopOffset())
  store.dispatch(closeModal())
  store.dispatch(unBlockFeatures())
})
